import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import GuardedElement from './GuardedElement';

import Sidebar from '../Components/Sidebar/Sidebar';

import Dashboard from '../Pages/Dashboard/Dashboard';
import OppDashboard from '../Pages/Dashboard/Opportunities/DashboardOpportunities';
import Personal from '../Pages/Dashboard/Personal/Personal';

import Opportunities from '../Pages/Opportunities/Main/Opportunities';

import Projects from '../Pages/Projects/Projects';
import ProjectList from '../Pages/Projects/ProjectList/ProjectList';
import ProjectProfile from '../Pages/Projects/ProjectProfile/ProjectProfile';

import Timesheets from '../Pages/Timesheets/Main/Timesheets';

import Client from '../Pages/Client/Client';
import ClientList from '../Pages/Client/ClientList/ClientList';
import ClientProfile from '../Pages/Client/ClientProfile/ClientProfile';

import Suppliers from '../Pages/Suppliers/Suppliers';
import SuppliersList from '../Pages/Suppliers/SuppliersList/SuppliersList';
import SuppliersProfile from '../Pages/Suppliers/SuppliersProfile/SuppliersProfile';

import Resourcing from '../Pages/Resourcing/Resourcing';

import Invoicing from '../Pages/Invoicing/Main/Invoicing';
import InvoiceList from '../Pages/Invoicing/Main/InvoicingList';
import RaiseInvoice from '../Pages/RaiseInvoice/RaiseInvoice';

import Profile from '../Pages/Profile/Profile';
import Holiday from '../Pages/Profile/Holiday/Holiday';
import Sickness from '../Pages/Profile/Sickness/Sickness';
import UserInfo from '../Pages/Profile/Users/Users';

import Approvals from '../Pages/Admin/Admin';
import ApprovalHoliday from '../Pages/Admin/Holiday/Holiday';
import ApprovalEmployeeInfo from '../Pages/Admin/Users/UsersList';
import AdminSickness from '../Pages/Admin/Sickness/Sickness';
import Settings from '../Pages/Admin/Settings/Settings';
import Discrepancies from '../Pages/Admin/Discrepancies';
import NotRegistered from '../Pages/NotRegistered/NotRegistered';

export default function AppRoutes({
  isAdmin,
  accessLoaded,
  allowedPrefixes,
  lastDeniedPath,
  onDenied,
  lastAllowedPath,
  shouldRedirectOnDenied,
  fallbackAllowedPath,
}) {
  const guardProps = {
    accessLoaded,
    allowedPrefixes,
    lastDeniedPath,
    onDenied,
    lastAllowedPath,
    shouldRedirectOnDenied,
    fallbackAllowedPath,
  };

  return (
    <div className="app-container">
      <Sidebar />

      <Routes>
        <Route path="/" element={<Navigate to="/dashboard/personal" />} />
        <Route path="/not-registered" element={<NotRegistered />} />

        <Route
          path="/dashboard"
          element={<GuardedElement prefix="/dashboard" element={<Dashboard />} {...guardProps} />}
        >
          <Route index element={<Navigate to="./personal" />} />
          <Route path="personal" element={<Personal />} />
          {/* Admin-only dashboard routes */}
          <Route path="opportunities" element={isAdmin ? <OppDashboard /> : null} />
          <Route path="resourcing" element={isAdmin ? <Resourcing /> : null} />
        </Route>

        <Route
          path="/Profile"
          element={<GuardedElement prefix="/Profile" element={<Profile />} {...guardProps} />}
        >
          <Route path="/Profile" element={<Navigate to="./Leave" />} />
          <Route path="Leave" element={<Holiday />} />
          <Route path="Sickness" element={<Sickness />} />
          <Route path="User" element={<UserInfo editable={false} />} />
        </Route>

        <Route
          path="/projects"
          element={<GuardedElement prefix="/projects" element={<Projects />} {...guardProps} />}
        >
          <Route index element={<ProjectList />} />
          <Route path="Projects" element={<ProjectList />} />
          <Route path="ProjectProfile" element={<ProjectProfile />} />
        </Route>

        <Route
          path="/invoicing"
          element={<GuardedElement prefix="/invoicing" element={<InvoiceList />} {...guardProps} />}
        />

        <Route
          path="/invoicing/raise-invoice"
          element={<GuardedElement prefix="/invoicing" element={<RaiseInvoice />} {...guardProps} />}
        />
        <Route
          path="/invoicing/draft-invoice"
          element={<GuardedElement prefix="/invoicing" element={<RaiseInvoice />} {...guardProps} />}
        />

        <Route
          path="/dashboard/invoicing"
          element={<GuardedElement prefix="/invoicing" element={<Invoicing />} {...guardProps} />}
        />

        <Route
          path="/timesheets"
          element={<GuardedElement prefix="/timesheets" element={<Timesheets />} {...guardProps} />}
        />

        <Route path="/opportunities">
          <Route
            index
            element={<GuardedElement prefix="/opportunities" element={<Opportunities />} {...guardProps} />}
          />
          <Route
            path="OppProfile"
            element={<GuardedElement prefix="/opportunities" element={<ProjectProfile />} {...guardProps} />}
          />
        </Route>

        <Route
          path="/clients"
          element={<GuardedElement prefix="/clients" element={<Client />} {...guardProps} />}
        >
          <Route index element={<ClientList />} />
          <Route path="Client" element={<ClientList />} />
          <Route path="ClientProfile" element={<ClientProfile />} />
        </Route>

        <Route
          path="/suppliers"
          element={<GuardedElement prefix="/suppliers" element={<Suppliers />} {...guardProps} />}
        >
          <Route index element={<SuppliersList />} />
          <Route path="Suppliers" element={<SuppliersList />} />
          <Route path="SupplierProfile" element={<SuppliersProfile />} />
        </Route>

        <Route
          path="/resourcing"
          element={<GuardedElement prefix="/resourcing" element={<Resourcing />} {...guardProps} />}
        />

        <Route
          path="/Admin"
          element={<GuardedElement prefix="/Admin" element={<Approvals />} {...guardProps} />}
        >
          <Route path="/Admin" element={<Navigate to="./Leave" />} />
          <Route path="Leave" element={<ApprovalHoliday />} />
          <Route path="Sickness" element={<AdminSickness />} />
          <Route path="Users" element={<ApprovalEmployeeInfo />}>
            <Route path="Profile" element={<UserInfo editable={true} />} />
          </Route>
          <Route path="Discrepancies" element={<Discrepancies />} />
          <Route path="Settings" element={<Settings />} />
        </Route>
      </Routes>
      <div className="MomentLogo">MOMENT</div>
    </div>
  );
}
